import ScrollReveal from 'scrollreveal'

document.addEventListener("DOMContentLoaded", function () {

	//if desktop and NOT IE
	if(window.matchMedia("(min-width: 1280px)").matches && !((navigator.userAgent).indexOf("MSIE ") > -1 || (navigator.userAgent).indexOf("Trident/") > -1)) {

		// Fifty fifty block
		ScrollReveal({delay: 200, origin: 'left'}).reveal('.fifty-fifty-block .img-wrapper.image-left img');
		ScrollReveal({delay: 200, origin: 'right'}).reveal('.fifty-fifty-block .img-wrapper img');

        // Stats block
        ScrollReveal({delay: 200, origin: 'top'}).reveal('.stats-block .stat-item:nth-child(1) .content .heading');
        ScrollReveal({delay: 300, origin: 'top'}).reveal('.stats-block .stat-item:nth-child(2) .content .heading');
        ScrollReveal({delay: 400,origin: 'top'}).reveal('.stats-block .stat-item:nth-child(3) .content .heading');
        
        // Columns block 
        ScrollReveal({delay: 200, opacity: 0}).reveal('.columns-block .column-item');

        // Related products
        ScrollReveal({delay: 200, opacity: 0}).reveal('.related-products .post-loop-product');

		function resetSVG(el) {
			el.style.removeProperty("visibility");
			el.style.removeProperty("opacity");
			el.style.removeProperty("transform");
			el.style.removeProperty("transition");
		}

		//Blog
		if(document.body.classList.contains('blog')) {

			//fetch all visible blog items
			let blog_items = document.getElementsByClassName('post-snippet');

			//if we have some items to visit
			if(blog_items.length) {

				//loop over them
				for(let i = 0; i < blog_items.length; i++) {
					
					//apply the reveal effect with a delay to prevent all items appearing at once
					ScrollReveal({distance: '25px', origin: 'top', delay: 0 + (i * 50)}).reveal(blog_items[i]);	
				}
			}
		}

		//Footer

		//Footer Social Icons
		ScrollReveal({delay: 300, opacity: 0}).reveal('#footer-social > a:nth-child(1)');	
		ScrollReveal({delay: 400}).reveal('#footer-social > a:nth-child(2)');	
		ScrollReveal({delay: 500}).reveal('#footer-social > a:nth-child(3)');	
		ScrollReveal({delay: 600}).reveal('#footer-social > a:nth-child(4)');	
		ScrollReveal({delay: 700}).reveal('#footer-social > a:nth-child(5)');
		ScrollReveal({delay: 800}).reveal('#footer-social > a:nth-child(6)');
	}

});